// =============================================
// aidPlannerFeeSchedules.js
// VLA Fee Schedule Data — effective 01/01/2026
// =============================================

// =============================================
// TABLE A4 — Family Violence Protection Act
// =============================================
export const FAMILY_VIOLENCE_CLAIM_ROWS = [
  {
    appearanceType: "FV PREPARATION",
    feeType: "FV PREPARATION",
    amountLabel: "LUMP SUM $431.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "Preparation fee — covers all necessary work for family violence intervention order matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "FV URGENT PREPARATION",
    feeType: "FV URGENT PREPARATION",
    amountLabel: "LUMP SUM $247.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "Urgent preparation for family violence intervention order matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "FV COURT ORDERED CROSS EXAMINATION PREPARATION",
    feeType: "FV COURT ORDERED CROSS EXAMINATION PREPARATION",
    amountLabel: "LUMP SUM $247.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "Preparation for court-ordered cross examination in family violence matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "FV DIRECTIONS HEARING",
    feeType: "FV DIRECTIONS HEARING",
    amountLabel: "3 APPEARANCE(s) @ $161.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "Directions hearing appearance — not normally payable in court-ordered representation matters",
    effectiveFrom: "11/05/2025",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "FV APPEARANCE",
    feeType: "FV APPEARANCE",
    amountLabel: "3 DAY(s) @ $431.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "General hearing appearance for family violence intervention order matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "FV CONTEST APPEARANCE",
    feeType: "FV CONTEST APPEARANCE",
    amountLabel: "3 DAY(s) @ $605.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "Contested hearing appearance for family violence intervention order matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "FV ADJOURNMENT",
    feeType: "FV ADJOURNMENT",
    amountLabel: "2 APPEARANCE(s) @ $431.00",
    table: "Table A4 – Family Violence Protection Act",
    note: "Adjournment appearance for family violence intervention order matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "FV TRAVEL",
    feeType: "FV TRAVEL",
    amountLabel: "600 KM @ $0.83",
    table: "Table A4 – Family Violence Protection Act",
    note: "Travel fee per kilometre for family violence matter",
    effectiveFrom: "11/05/2025",
    allocationCount: 600,
    allocationUnit: "km",
    trackerAliases: [],
  },
  {
    appearanceType: "FV OVERNIGHT",
    feeType: "FV OVERNIGHT",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table A4 – Family Violence Protection Act",
    // The handbook's Table A4 shows $385, which is a handbook error: VLA pays the same $394
    // overnight fee as every other table (confirmed by the firm, September 2026).
    note: "Overnight accommodation allowance for family violence matter — $394, the same as every other overnight fee",
    effectiveFrom: "11/05/2025",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: [],
  },
];

// =============================================
// TABLE B ADDITIONS — Bail Magistrates'/Children's Court
// =============================================
export const BAIL_TABLE_B_ADDITIONS = [
  {
    appearanceType: "INTENSIVE BAIL SCHEME SUPERVISION",
    feeType: "INTENSIVE BAIL SCHEME SUPERVISION",
    amountLabel: "LUMP SUM $185.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Intensive Bail Scheme supervision fee — Children's Court only",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["INTENSIVE BAIL SCHEME", "BAIL INTENSIVE SUPERVISION"],
  },
];

// =============================================
// TABLE C — County Court Bail
// =============================================
export const COUNTY_COURT_BAIL_CLAIM_ROWS = [
  {
    appearanceType: "CC BAIL PREPARATION",
    feeType: "CC BAIL PREPARATION",
    amountLabel: "LUMP SUM $1,030.00",
    table: "Table C – County Court Bail",
    note: "Preparation for County Court bail application",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC BAIL APPEARANCE",
    feeType: "CC BAIL APPEARANCE",
    amountLabel: "3 APPEARANCE(s) @ $968.00",
    table: "Table C – County Court Bail",
    note: "Appearance at County Court bail hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC BAIL MENTION",
    feeType: "CC BAIL MENTION",
    amountLabel: "3 APPEARANCE(s) @ $298.00",
    table: "Table C – County Court Bail",
    note: "Mention appearance at County Court for bail matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC BAIL TRAVEL FEE",
    feeType: "CC BAIL TRAVEL FEE",
    amountLabel: "600 KM @ $0.83",
    table: "Table C – County Court Bail",
    note: "Travel fee per kilometre for County Court bail",
    effectiveFrom: "01/01/2026",
    allocationCount: 600,
    allocationUnit: "km",
    trackerAliases: [],
  },
  {
    appearanceType: "CC BAIL OVERNIGHT",
    feeType: "CC BAIL OVERNIGHT",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table C – County Court Bail",
    note: "Overnight accommodation allowance for County Court bail",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: [],
  },
];

// =============================================
// TABLE D — Supreme Court Bail
// =============================================
export const SUPREME_COURT_BAIL_CLAIM_ROWS = [
  {
    appearanceType: "SC BAIL PREPARATION",
    feeType: "SC BAIL PREPARATION",
    amountLabel: "LUMP SUM $1,043.00",
    table: "Table D – Supreme Court Bail",
    note: "Preparation fee (3.5 hours) — covers all work for Supreme Court bail",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC BAIL APPEARANCE",
    feeType: "SC BAIL APPEARANCE",
    amountLabel: "1 APPEARANCE @ $1,041.00",
    table: "Table D – Supreme Court Bail",
    note: "Appearance at Supreme Court bail hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC BAIL TRAVEL FEE",
    feeType: "SC BAIL TRAVEL FEE",
    amountLabel: "600 KM @ $0.83",
    table: "Table D – Supreme Court Bail",
    note: "Travel fee per kilometre for Supreme Court bail",
    effectiveFrom: "01/01/2026",
    allocationCount: 600,
    allocationUnit: "km",
    trackerAliases: [],
  },
  {
    appearanceType: "SC BAIL OVERNIGHT",
    feeType: "SC BAIL OVERNIGHT",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table D – Supreme Court Bail",
    note: "Overnight accommodation allowance for Supreme Court bail",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: [],
  },
];

// =============================================
// TABLE E — Indictable Committal (Magistrates'/Children's Court)
// =============================================
export const INDICTABLE_COMMITTAL_CLAIM_ROWS = [
  {
    appearanceType: "COMMITTAL PREPARATION",
    feeType: "COMMITTAL PREPARATION",
    amountLabel: "LUMP SUM $712.00",
    table: "Table E – Indictable Committal",
    note: "Preparation fee (4 hours) for committal proceedings",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL BRIEF ANALYSIS",
    feeType: "COMMITTAL BRIEF ANALYSIS",
    amountLabel: "LUMP SUM $712.00",
    table: "Table E – Indictable Committal",
    note: "Brief analysis and case strategy fee (4 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL ADDITIONAL PREPARATION",
    feeType: "COMMITTAL ADDITIONAL PREPARATION",
    amountLabel: "LUMP SUM $890.00",
    table: "Table E – Indictable Committal",
    note: "Additional preparation fee (5 hours) for contested committal or negotiations",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL MENTION",
    feeType: "COMMITTAL MENTION",
    amountLabel: "3 APPEARANCE(s) @ $445.00",
    table: "Table E – Indictable Committal",
    note: "Appearance at committal mention, case conference, summary jurisdiction application, or leave to cross-examine",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL GROUND RULES HEARING",
    feeType: "COMMITTAL GROUND RULES HEARING",
    amountLabel: "3 DAY(s) @ $484.00",
    table: "Table E – Indictable Committal",
    note: "Ground rules hearing at committal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL SPECIAL MENTION",
    feeType: "COMMITTAL SPECIAL MENTION",
    amountLabel: "3 APPEARANCE(s) @ $178.00",
    table: "Table E – Indictable Committal",
    note: "Special mention appearance (1 hour each)",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL CONTEST DAY 1",
    feeType: "COMMITTAL CONTEST DAY 1",
    amountLabel: "1 APPEARANCE @ $1,284.00",
    table: "Table E – Indictable Committal",
    note: "First day of contested committal hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL CONTEST DAY 2+",
    feeType: "COMMITTAL CONTEST DAY 2+",
    amountLabel: "3 APPEARANCE(s) @ $1,157.00",
    table: "Table E – Indictable Committal",
    // The handbook lists "day 2" only, but days 2, 3 and 4 are all paid at the day 2 rate.
    note: "Days 2, 3 and 4 of a contested committal hearing, each at the day 2 rate",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL JAIL CONFERENCE",
    feeType: "COMMITTAL JAIL CONFERENCE",
    amountLabel: "LUMP SUM $185.00",
    table: "Table E – Indictable Committal",
    note: "Jail conference fee for committal matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL PLEA",
    feeType: "COMMITTAL PLEA",
    amountLabel: "LUMP SUM $537.00",
    table: "Table E – Indictable Committal",
    note: "Plea at committal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COMMITTAL SENTENCE",
    feeType: "COMMITTAL SENTENCE",
    amountLabel: "1 APPEARANCE @ $318.00",
    table: "Table E – Indictable Committal",
    note: "Sentence appearance if heard on a different day to the plea",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

// =============================================
// TABLE F — County Court Indictable
// =============================================
export const COUNTY_COURT_INDICTABLE_CLAIM_ROWS = [
  // --- Post-committal general ---
  {
    appearanceType: "CC POST-COMMITTAL NEGOTIATIONS",
    feeType: "CC POST-COMMITTAL NEGOTIATIONS",
    amountLabel: "LUMP SUM $714.00",
    table: "Table F – County Court Indictable",
    note: "Post-committal negotiations (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC FIRST DIRECTIONS HEARING",
    feeType: "CC FIRST DIRECTIONS HEARING",
    amountLabel: "LUMP SUM $476.00",
    table: "Table F – County Court Indictable",
    note: "First directions hearing (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC DIRECTIONS HEARING",
    feeType: "CC DIRECTIONS HEARING",
    amountLabel: "3 APPEARANCE(s) @ $297.00",
    table: "Table F – County Court Indictable",
    note: "Subsequent directions hearing appearances (1.25 hours each)",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC DEFENCE RESPONSE DIRECTIONS",
    feeType: "CC DEFENCE RESPONSE DIRECTIONS",
    amountLabel: "LUMP SUM $476.00",
    table: "Table F – County Court Indictable",
    note: "Defence response to directions (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC APPLICATION DISCONTINUANCE",
    feeType: "CC APPLICATION DISCONTINUANCE",
    amountLabel: "LUMP SUM $595.00",
    table: "Table F – County Court Indictable",
    note: "Application for discontinuance (2.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  // --- Plea fees ---
  {
    appearanceType: "CC PLEA PREPARATION",
    feeType: "CC PLEA PREPARATION",
    amountLabel: "LUMP SUM $561.00",
    table: "Table F – County Court Indictable",
    note: "Plea preparation (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC PLEA APPEARANCE DAY 1",
    feeType: "CC PLEA APPEARANCE DAY 1",
    amountLabel: "1 APPEARANCE @ $1,834.00",
    table: "Table F – County Court Indictable",
    note: "First day plea appearance (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC PLEA APPEARANCE SUBSEQUENT",
    feeType: "CC PLEA APPEARANCE SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $638.00",
    table: "Table F – County Court Indictable",
    note: "Subsequent plea appearance days",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SENTENCE",
    feeType: "CC SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $356.00",
    table: "Table F – County Court Indictable",
    note: "Sentence hearing appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ADVICE ON APPEAL",
    feeType: "CC ADVICE ON APPEAL",
    amountLabel: "LUMP SUM $326.00",
    table: "Table F – County Court Indictable",
    note: "Advice on appeal (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  // --- Special hearing ---
  {
    appearanceType: "CC SPECIAL HEARING PREPARATION",
    feeType: "CC SPECIAL HEARING PREPARATION",
    amountLabel: "LUMP SUM $187.00",
    table: "Table F – County Court Indictable",
    note: "Special hearing preparation (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SPECIAL HEARING DAY 1",
    feeType: "CC SPECIAL HEARING DAY 1",
    amountLabel: "1 APPEARANCE @ $2,501.00",
    table: "Table F – County Court Indictable",
    note: "First day of special hearing (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SPECIAL HEARING SUBSEQUENT",
    feeType: "CC SPECIAL HEARING SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,370.00",
    table: "Table F – County Court Indictable",
    note: "Subsequent days of special hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  // --- Sentence indication ---
  {
    appearanceType: "CC SENTENCE INDICATION",
    feeType: "CC SENTENCE INDICATION",
    amountLabel: "1 APPEARANCE @ $1,350.00",
    table: "Table F – County Court Indictable",
    note: "Sentence indication appearance (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Intermediaries/ground rules ---
  {
    appearanceType: "CC GROUND RULES HEARING",
    feeType: "CC GROUND RULES HEARING",
    amountLabel: "3 DAY(s) @ $1,370.00",
    table: "Table F – County Court Indictable",
    note: "Ground rules hearing at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  // --- Section 198A (County Court only) ---
  {
    appearanceType: "CC S198A APPLICATION",
    feeType: "CC S198A APPLICATION",
    amountLabel: "LUMP SUM $714.00",
    table: "Table F – County Court Indictable",
    note: "Section 198A application (County Court only)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC S198A EXAMINATION",
    feeType: "CC S198A EXAMINATION",
    amountLabel: "1 APPEARANCE @ $1,370.00",
    table: "Table F – County Court Indictable",
    note: "Section 198A examination appearance (County Court only)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- ACMS (Active Case Management System) ---
  {
    appearanceType: "CC ACMS CASE INITIATION",
    feeType: "CC ACMS CASE INITIATION",
    amountLabel: "LUMP SUM $476.00",
    table: "Table F – County Court Indictable",
    note: "ACMS case initiation",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ACMS INSTRUCTOR PREPARATION",
    feeType: "CC ACMS INSTRUCTOR PREPARATION",
    amountLabel: "LUMP SUM $714.00",
    table: "Table F – County Court Indictable",
    note: "ACMS instructor preparation",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ACMS COUNSEL PREPARATION",
    feeType: "CC ACMS COUNSEL PREPARATION",
    amountLabel: "LUMP SUM $1,612.00",
    table: "Table F – County Court Indictable",
    note: "ACMS counsel preparation",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ACMS APPEARANCE",
    feeType: "CC ACMS APPEARANCE",
    amountLabel: "3 APPEARANCE(s) @ $1,370.00",
    table: "Table F – County Court Indictable",
    note: "ACMS appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ACMS INSTRUCTING",
    feeType: "CC ACMS INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $165.00",
    table: "Table F – County Court Indictable",
    note: "ACMS instructing solicitor fee per hour",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ACMS TRQ CERTIFICATE",
    feeType: "CC ACMS TRQ CERTIFICATE",
    amountLabel: "LUMP SUM $476.00",
    table: "Table F – County Court Indictable",
    note: "ACMS TRQ certificate",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC ACMS CASE ASSESSMENT",
    feeType: "CC ACMS CASE ASSESSMENT",
    amountLabel: "LUMP SUM $596.00",
    table: "Table F – County Court Indictable",
    note: "ACMS case assessment",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  // --- Trial ---
  {
    appearanceType: "CC TRIAL PREPARATION",
    feeType: "CC TRIAL PREPARATION",
    amountLabel: "LUMP SUM $1,870.00",
    table: "Table F – County Court Indictable",
    note: "Trial preparation (10 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL DEFENCE RESPONSE",
    feeType: "CC TRIAL DEFENCE RESPONSE",
    amountLabel: "LUMP SUM $476.00",
    table: "Table F – County Court Indictable",
    note: "Trial defence response (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL APPEARANCE DAY 1",
    feeType: "CC TRIAL APPEARANCE DAY 1",
    amountLabel: "1 APPEARANCE @ $2,982.00",
    table: "Table F – County Court Indictable",
    note: "First day of trial (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL APPEARANCE DAY 1 UPLIFT",
    feeType: "CC TRIAL APPEARANCE DAY 1 UPLIFT",
    amountLabel: "1 APPEARANCE @ $3,578.00",
    table: "Table F – County Court Indictable",
    note: "First day of trial with 20% uplift",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL SUBSEQUENT",
    feeType: "CC TRIAL SUBSEQUENT",
    amountLabel: "5 DAY(s) @ $1,370.00",
    table: "Table F – County Court Indictable",
    note: "Subsequent trial days",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL INSTRUCTING",
    feeType: "CC TRIAL INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $165.00",
    table: "Table F – County Court Indictable",
    note: "Instructing solicitor fee per hour during trial",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
  {
    appearanceType: "CC PLEA HEARING DAY 1",
    feeType: "CC PLEA HEARING DAY 1",
    amountLabel: "1 APPEARANCE @ $1,106.00",
    table: "Table F – County Court Indictable",
    note: "First day of plea hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC PLEA HEARING SUBSEQUENT",
    feeType: "CC PLEA HEARING SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $638.00",
    table: "Table F – County Court Indictable",
    note: "Subsequent plea hearing days",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL SENTENCE",
    feeType: "CC TRIAL SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $356.00",
    table: "Table F – County Court Indictable",
    note: "Sentence appearance following trial",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC TRIAL ADVICE ON APPEAL",
    feeType: "CC TRIAL ADVICE ON APPEAL",
    amountLabel: "LUMP SUM $978.00",
    table: "Table F – County Court Indictable",
    note: "Advice on appeal following trial (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
];

// =============================================
// TABLE F — Supreme Court Indictable
// =============================================
export const SUPREME_COURT_INDICTABLE_CLAIM_ROWS = [
  // --- Post-committal general ---
  {
    appearanceType: "SC POST-COMMITTAL NEGOTIATIONS",
    feeType: "SC POST-COMMITTAL NEGOTIATIONS",
    amountLabel: "LUMP SUM $978.00",
    table: "Table F – Supreme Court Indictable",
    note: "Post-committal negotiations (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC FIRST DIRECTIONS HEARING",
    feeType: "SC FIRST DIRECTIONS HEARING",
    amountLabel: "LUMP SUM $652.00",
    table: "Table F – Supreme Court Indictable",
    note: "First directions hearing (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC DIRECTIONS HEARING",
    feeType: "SC DIRECTIONS HEARING",
    amountLabel: "3 APPEARANCE(s) @ $407.00",
    table: "Table F – Supreme Court Indictable",
    note: "Subsequent directions hearing appearances (1.25 hours each)",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC DEFENCE RESPONSE DIRECTIONS",
    feeType: "SC DEFENCE RESPONSE DIRECTIONS",
    amountLabel: "LUMP SUM $652.00",
    table: "Table F – Supreme Court Indictable",
    note: "Defence response to directions (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC APPLICATION DISCONTINUANCE",
    feeType: "SC APPLICATION DISCONTINUANCE",
    amountLabel: "LUMP SUM $815.00",
    table: "Table F – Supreme Court Indictable",
    note: "Application for discontinuance (2.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  // --- Plea fees ---
  {
    appearanceType: "SC PLEA PREPARATION",
    feeType: "SC PLEA PREPARATION",
    amountLabel: "LUMP SUM $2,533.00",
    table: "Table F – Supreme Court Indictable",
    note: "Plea preparation (8.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC PLEA APPEARANCE DAY 1",
    feeType: "SC PLEA APPEARANCE DAY 1",
    amountLabel: "1 APPEARANCE @ $2,504.00",
    table: "Table F – Supreme Court Indictable",
    note: "First day plea appearance (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC PLEA APPEARANCE SUBSEQUENT",
    feeType: "SC PLEA APPEARANCE SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,002.00",
    table: "Table F – Supreme Court Indictable",
    note: "Subsequent plea appearance days",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SC SENTENCE",
    feeType: "SC SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $491.00",
    table: "Table F – Supreme Court Indictable",
    note: "Sentence hearing appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC ADVICE ON APPEAL",
    feeType: "SC ADVICE ON APPEAL",
    amountLabel: "LUMP SUM $326.00",
    table: "Table F – Supreme Court Indictable",
    note: "Advice on appeal (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  // --- Special hearing ---
  {
    appearanceType: "SC SPECIAL HEARING PREPARATION",
    feeType: "SC SPECIAL HEARING PREPARATION",
    amountLabel: "LUMP SUM $298.00",
    table: "Table F – Supreme Court Indictable",
    note: "Special hearing preparation (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC SPECIAL HEARING DAY 1",
    feeType: "SC SPECIAL HEARING DAY 1",
    amountLabel: "1 APPEARANCE @ $3,410.00",
    table: "Table F – Supreme Court Indictable",
    note: "First day of special hearing (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC SPECIAL HEARING SUBSEQUENT",
    feeType: "SC SPECIAL HEARING SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $2,197.00",
    table: "Table F – Supreme Court Indictable",
    note: "Subsequent days of special hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  // --- Sentence indication ---
  {
    appearanceType: "SC SENTENCE INDICATION",
    feeType: "SC SENTENCE INDICATION",
    amountLabel: "1 APPEARANCE @ $1,838.00",
    table: "Table F – Supreme Court Indictable",
    note: "Sentence indication appearance (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Intermediaries/ground rules ---
  {
    appearanceType: "SC GROUND RULES HEARING",
    feeType: "SC GROUND RULES HEARING",
    amountLabel: "3 DAY(s) @ $2,197.00",
    table: "Table F – Supreme Court Indictable",
    note: "Ground rules hearing at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  // --- Case management (Supreme Court) ---
  {
    appearanceType: "SC S198B APPLICATION",
    feeType: "SC S198B APPLICATION",
    amountLabel: "LUMP SUM $894.00",
    table: "Table F – Supreme Court Indictable",
    note: "Section 198B application",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC S198B APPEARANCE",
    feeType: "SC S198B APPEARANCE",
    amountLabel: "3 DAY(s) @ $2,197.00",
    table: "Table F – Supreme Court Indictable",
    note: "Section 198B appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SC COUNSEL CALLOVER PREPARATION",
    feeType: "SC COUNSEL CALLOVER PREPARATION",
    amountLabel: "LUMP SUM $652.00",
    table: "Table F – Supreme Court Indictable",
    note: "Counsel callover preparation",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC CASE CONFERENCE",
    feeType: "SC CASE CONFERENCE",
    amountLabel: "3 APPEARANCE(s) @ $1,838.00",
    table: "Table F – Supreme Court Indictable",
    note: "Case conference appearance at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Trial ---
  {
    appearanceType: "SC TRIAL PREPARATION",
    feeType: "SC TRIAL PREPARATION",
    amountLabel: "LUMP SUM $4,470.00",
    table: "Table F – Supreme Court Indictable",
    note: "Trial preparation (15 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL DEFENCE RESPONSE",
    feeType: "SC TRIAL DEFENCE RESPONSE",
    amountLabel: "LUMP SUM $652.00",
    table: "Table F – Supreme Court Indictable",
    note: "Trial defence response (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL APPEARANCE DAY 1",
    feeType: "SC TRIAL APPEARANCE DAY 1",
    amountLabel: "1 APPEARANCE @ $4,737.00",
    table: "Table F – Supreme Court Indictable",
    note: "First day of trial (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL APPEARANCE DAY 1 UPLIFT",
    feeType: "SC TRIAL APPEARANCE DAY 1 UPLIFT",
    amountLabel: "1 APPEARANCE @ $5,684.00",
    table: "Table F – Supreme Court Indictable",
    note: "First day of trial with 20% uplift",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL SUBSEQUENT",
    feeType: "SC TRIAL SUBSEQUENT",
    amountLabel: "5 DAY(s) @ $2,197.00",
    table: "Table F – Supreme Court Indictable",
    note: "Subsequent trial days",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL INSTRUCTING",
    feeType: "SC TRIAL INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $298.00",
    table: "Table F – Supreme Court Indictable",
    note: "Instructing solicitor fee per hour during trial",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
  {
    appearanceType: "SC PLEA HEARING DAY 1",
    feeType: "SC PLEA HEARING DAY 1",
    amountLabel: "1 APPEARANCE @ $1,508.00",
    table: "Table F – Supreme Court Indictable",
    note: "First day of plea hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC PLEA HEARING SUBSEQUENT",
    feeType: "SC PLEA HEARING SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,002.00",
    table: "Table F – Supreme Court Indictable",
    note: "Subsequent plea hearing days",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL SENTENCE",
    feeType: "SC TRIAL SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $491.00",
    table: "Table F – Supreme Court Indictable",
    note: "Sentence appearance following trial",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC TRIAL ADVICE ON APPEAL",
    feeType: "SC TRIAL ADVICE ON APPEAL",
    amountLabel: "LUMP SUM $978.00",
    table: "Table F – Supreme Court Indictable",
    note: "Advice on appeal following trial (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
];

// =============================================
// TABLE F(i) — Children's Court Indictable (serious matters)
// =============================================
export const CHILDRENS_COURT_INDICTABLE_CLAIM_ROWS = [
  {
    appearanceType: "SERIOUS INDICTABLE PREPARATION",
    feeType: "SERIOUS INDICTABLE PREPARATION",
    amountLabel: "LUMP SUM $719.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Preparation for serious indictable matter (4 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE CONTEST MENTION",
    feeType: "SERIOUS INDICTABLE CONTEST MENTION",
    amountLabel: "3 APPEARANCE(s) @ $356.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Contest mention appearance for serious indictable matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE APPEARANCE",
    feeType: "SERIOUS INDICTABLE APPEARANCE",
    amountLabel: "5 DAY(s) @ $1,214.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Hearing appearance for serious indictable matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE SUMMARY JURISDICTION",
    feeType: "SERIOUS INDICTABLE SUMMARY JURISDICTION",
    amountLabel: "LUMP SUM $890.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Summary jurisdiction application (5 hours). $890 from 19/10/2026 (was $445, 2.5 hours).",
    effectiveFrom: "19/10/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE GROUP CONFERENCE",
    feeType: "SERIOUS INDICTABLE GROUP CONFERENCE",
    amountLabel: "1 CONFERENCE @ $534.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Group conference during work hours",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "conference",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE GROUP CONFERENCE AFTER HOURS",
    feeType: "SERIOUS INDICTABLE GROUP CONFERENCE AFTER HOURS",
    amountLabel: "1 CONFERENCE @ $712.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Group conference after hours",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "conference",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE YCO PLANNING",
    feeType: "SERIOUS INDICTABLE YCO PLANNING",
    amountLabel: "1 MEETING @ $358.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Youth Control Order planning meeting",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "meeting",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE YCO MONITORING",
    feeType: "SERIOUS INDICTABLE YCO MONITORING",
    amountLabel: "3 APPEARANCE(s) @ $185.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Youth Control Order monitoring appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE YCO OPPOSE VARIATION",
    feeType: "SERIOUS INDICTABLE YCO OPPOSE VARIATION",
    amountLabel: "2 APPEARANCE(s) @ $318.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Opposition to Youth Control Order variation",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE YCO BREACH",
    feeType: "SERIOUS INDICTABLE YCO BREACH",
    amountLabel: "1 APPEARANCE @ $484.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Youth Control Order breach appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE SENTENCE",
    feeType: "SERIOUS INDICTABLE SENTENCE",
    amountLabel: "1 APPEARANCE @ $358.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Sentence appearance if on a different day",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SERIOUS INDICTABLE TAPE TRANSCRIPTION",
    feeType: "SERIOUS INDICTABLE TAPE TRANSCRIPTION",
    amountLabel: "3 TAPE(s) @ $99.00",
    table: "Table F(i) – Children's Court Indictable",
    note: "Tape transcription disbursement",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "tape",
    trackerAliases: [],
  },
];

// =============================================
// TABLE G — County Court Sentence Appeal
// =============================================
export const COUNTY_COURT_SENTENCE_APPEAL_CLAIM_ROWS = [
  {
    appearanceType: "CC SENTENCE APPEAL PREPARATION",
    feeType: "CC SENTENCE APPEAL PREPARATION",
    amountLabel: "LUMP SUM $1,030.00",
    table: "Table G – County Court Sentence Appeal",
    note: "Preparation for County Court sentence appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SENTENCE APPEAL APPEARANCE",
    feeType: "CC SENTENCE APPEAL APPEARANCE",
    amountLabel: "3 APPEARANCE(s) @ $968.00",
    table: "Table G – County Court Sentence Appeal",
    note: "Appearance at County Court sentence appeal hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SENTENCE APPEAL SENTENCE HEARING",
    feeType: "CC SENTENCE APPEAL SENTENCE HEARING",
    amountLabel: "1 APPEARANCE @ $356.00",
    table: "Table G – County Court Sentence Appeal",
    note: "Sentence hearing following successful appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SENTENCE APPEAL MENTION",
    feeType: "CC SENTENCE APPEAL MENTION",
    amountLabel: "2 APPEARANCE(s) @ $298.00",
    table: "Table G – County Court Sentence Appeal",
    note: "Mention appearance in County Court sentence appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SENTENCE APPEAL TRAVEL",
    feeType: "CC SENTENCE APPEAL TRAVEL",
    amountLabel: "600 KM @ $0.83",
    table: "Table G – County Court Sentence Appeal",
    note: "Travel fee per kilometre for County Court sentence appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 600,
    allocationUnit: "km",
    trackerAliases: [],
  },
  {
    appearanceType: "CC SENTENCE APPEAL OVERNIGHT",
    feeType: "CC SENTENCE APPEAL OVERNIGHT",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table G – County Court Sentence Appeal",
    note: "Overnight accommodation allowance for County Court sentence appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: [],
  },
];

// =============================================
// TABLE H — County Court Appeal (Conviction + Sentence)
// =============================================
export const COUNTY_COURT_CONVICTION_APPEAL_CLAIM_ROWS = [
  {
    appearanceType: "CC CONVICTION APPEAL PREPARATION",
    feeType: "CC CONVICTION APPEAL PREPARATION",
    amountLabel: "LUMP SUM $1,028.00",
    table: "Table H – County Court Conviction and Sentence Appeal",
    note: "Preparation for County Court conviction appeal (5.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CC CONVICTION APPEAL MENTION",
    feeType: "CC CONVICTION APPEAL MENTION",
    amountLabel: "2 APPEARANCE(s) @ $297.00",
    table: "Table H – County Court Conviction and Sentence Appeal",
    note: "Mention appearance in County Court conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC CONVICTION APPEAL APPEARANCE",
    feeType: "CC CONVICTION APPEAL APPEARANCE",
    amountLabel: "3 DAY(s) @ $1,087.00",
    table: "Table H – County Court Conviction and Sentence Appeal",
    note: "Hearing appearance in County Court conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "CC CONVICTION APPEAL SENTENCE",
    feeType: "CC CONVICTION APPEAL SENTENCE",
    amountLabel: "1 APPEARANCE @ $356.00",
    table: "Table H – County Court Conviction and Sentence Appeal",
    note: "Sentence hearing following successful conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CC CONVICTION APPEAL TRAVEL",
    feeType: "CC CONVICTION APPEAL TRAVEL",
    amountLabel: "600 KM @ $0.83",
    table: "Table H – County Court Conviction and Sentence Appeal",
    note: "Travel fee per kilometre for County Court conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 600,
    allocationUnit: "km",
    trackerAliases: [],
  },
  {
    appearanceType: "CC CONVICTION APPEAL OVERNIGHT",
    feeType: "CC CONVICTION APPEAL OVERNIGHT",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table H – County Court Conviction and Sentence Appeal",
    note: "Overnight accommodation allowance for County Court conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: [],
  },
];

// =============================================
// TABLE J — Supreme Court Breach
// (County Court Breach already exists in aidPlannerCriminalFees.js)
// =============================================
export const SUPREME_COURT_BREACH_CLAIM_ROWS = [
  {
    appearanceType: "SC BREACH PREPARATION",
    feeType: "SC BREACH PREPARATION",
    amountLabel: "LUMP SUM $2,086.00",
    table: "Table J – Supreme Court Breach",
    note: "Preparation for Supreme Court breach hearing (5.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SC BREACH MENTION",
    feeType: "SC BREACH MENTION",
    amountLabel: "2 APPEARANCE(s) @ $407.00",
    table: "Table J – Supreme Court Breach",
    note: "Mention appearance in Supreme Court breach proceeding",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SC BREACH APPEARANCE",
    feeType: "SC BREACH APPEARANCE",
    amountLabel: "3 DAY(s) @ $2,273.00",
    table: "Table J – Supreme Court Breach",
    note: "Hearing appearance in Supreme Court breach proceeding",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SC BREACH SENTENCE",
    feeType: "SC BREACH SENTENCE",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table J – Supreme Court Breach",
    note: "Sentence appearance following Supreme Court breach finding",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

// =============================================
// TABLE K — Court of Appeal (convicted person)
// =============================================
export const COURT_OF_APPEAL_CLAIM_ROWS = [
  // --- Leave application ---
  {
    appearanceType: "COA LEAVE PREPARATION",
    feeType: "COA LEAVE PREPARATION",
    amountLabel: "LUMP SUM $596.00",
    table: "Table K – Court of Appeal",
    note: "Leave application preparation (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA GROUNDS OF APPEAL (CONVICTION)",
    feeType: "COA GROUNDS OF APPEAL (CONVICTION)",
    amountLabel: "LUMP SUM $1,630.00",
    table: "Table K – Court of Appeal",
    note: "Grounds of appeal for conviction (5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA GROUNDS OF APPEAL (SENTENCE)",
    feeType: "COA GROUNDS OF APPEAL (SENTENCE)",
    amountLabel: "LUMP SUM $978.00",
    table: "Table K – Court of Appeal",
    note: "Grounds of appeal for sentence (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA REVISION OF GROUNDS",
    feeType: "COA REVISION OF GROUNDS",
    amountLabel: "LUMP SUM $326.00",
    table: "Table K – Court of Appeal",
    note: "Revision of grounds of appeal (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA RENEWAL APPLICATION",
    feeType: "COA RENEWAL APPLICATION",
    amountLabel: "LUMP SUM $326.00",
    table: "Table K – Court of Appeal",
    note: "Renewal application preparation (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA ORAL HEARING",
    feeType: "COA ORAL HEARING",
    amountLabel: "1 APPEARANCE @ $326.00",
    table: "Table K – Court of Appeal",
    note: "Oral leave hearing appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Election to renew leave ---
  {
    appearanceType: "COA RENEWAL PREPARATION",
    feeType: "COA RENEWAL PREPARATION",
    amountLabel: "LUMP SUM $298.00",
    table: "Table K – Court of Appeal",
    note: "Election to renew leave — preparation (1 hour)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA RENEWAL GROUNDS",
    feeType: "COA RENEWAL GROUNDS",
    amountLabel: "LUMP SUM $652.00",
    table: "Table K – Court of Appeal",
    note: "Election to renew leave — grounds (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA RENEWAL BRIEF",
    feeType: "COA RENEWAL BRIEF",
    amountLabel: "1 APPEARANCE @ $631.00",
    table: "Table K – Court of Appeal",
    note: "Renewal brief — includes first day appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COA RENEWAL SUBSEQUENT",
    feeType: "COA RENEWAL SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $326.00",
    table: "Table K – Court of Appeal",
    note: "Subsequent days for renewal hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "COA RENEWAL JUDGMENT",
    feeType: "COA RENEWAL JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table K – Court of Appeal",
    note: "Judgment appearance for renewal application",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Appeal against sentence ---
  {
    appearanceType: "COA SENTENCE SOLICITOR PREPARATION",
    feeType: "COA SENTENCE SOLICITOR PREPARATION",
    amountLabel: "LUMP SUM $894.00",
    table: "Table K – Court of Appeal",
    note: "Solicitor preparation for sentence appeal (3 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA SENTENCE BRIEF",
    feeType: "COA SENTENCE BRIEF",
    amountLabel: "1 APPEARANCE @ $2,269.00",
    table: "Table K – Court of Appeal",
    note: "Brief for sentence appeal — includes preparation",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COA SENTENCE SUBSEQUENT",
    feeType: "COA SENTENCE SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,511.00",
    table: "Table K – Court of Appeal",
    note: "Subsequent days for sentence appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "COA SENTENCE JUDGMENT",
    feeType: "COA SENTENCE JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table K – Court of Appeal",
    note: "Judgment appearance for sentence appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Appeal against conviction/conviction and sentence ---
  {
    appearanceType: "COA CONVICTION SOLICITOR PREPARATION",
    feeType: "COA CONVICTION SOLICITOR PREPARATION",
    amountLabel: "LUMP SUM $1,490.00",
    table: "Table K – Court of Appeal",
    note: "Solicitor preparation for conviction appeal (5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA CONVICTION BRIEF",
    feeType: "COA CONVICTION BRIEF",
    amountLabel: "1 APPEARANCE @ $2,269.00",
    table: "Table K – Court of Appeal",
    note: "Brief for conviction appeal — includes preparation",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COA CONVICTION SUBSEQUENT",
    feeType: "COA CONVICTION SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,511.00",
    table: "Table K – Court of Appeal",
    note: "Subsequent days for conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "COA CONVICTION JUDGMENT",
    feeType: "COA CONVICTION JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table K – Court of Appeal",
    note: "Judgment appearance for conviction appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

// =============================================
// TABLE K(i) — Court of Appeal DPP
// =============================================
export const COURT_OF_APPEAL_DPP_CLAIM_ROWS = [
  {
    appearanceType: "COA DPP SOLICITOR PREPARATION",
    feeType: "COA DPP SOLICITOR PREPARATION",
    amountLabel: "LUMP SUM $1,937.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Solicitor preparation for DPP appeal (6.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP SC APPEARANCE",
    feeType: "COA DPP SC APPEARANCE",
    amountLabel: "1 APPEARANCE @ $5,203.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Senior Counsel appearance for DPP appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP SC SUBSEQUENT",
    feeType: "COA DPP SC SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $4,310.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Subsequent days for Senior Counsel in DPP appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP SC SUBMISSIONS",
    feeType: "COA DPP SC SUBMISSIONS",
    amountLabel: "LUMP SUM $4,360.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Senior Counsel written submissions for DPP appeal (10 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP JC BRIEF",
    feeType: "COA DPP JC BRIEF",
    amountLabel: "1 APPEARANCE @ $2,228.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Junior Counsel brief appearance for DPP appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP JC SUBSEQUENT",
    feeType: "COA DPP JC SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,854.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Subsequent days for Junior Counsel in DPP appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP JC SUBMISSIONS",
    feeType: "COA DPP JC SUBMISSIONS",
    amountLabel: "LUMP SUM $3,260.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Junior Counsel written submissions for DPP appeal (10 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "COA DPP JUDGMENT",
    feeType: "COA DPP JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table K(i) – Court of Appeal DPP",
    note: "Judgment appearance for DPP appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

// =============================================
// TABLE K(ii) — Interlocutory Appeal
// =============================================
export const INTERLOCUTORY_APPEAL_CLAIM_ROWS = [
  {
    appearanceType: "INTERLOCUTORY SOLICITOR PREPARATION",
    feeType: "INTERLOCUTORY SOLICITOR PREPARATION",
    amountLabel: "LUMP SUM $596.00",
    table: "Table K(ii) – Interlocutory Appeal",
    note: "Solicitor preparation for interlocutory appeal (2 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "INTERLOCUTORY COUNSEL PREPARATION",
    feeType: "INTERLOCUTORY COUNSEL PREPARATION",
    amountLabel: "LUMP SUM $652.00",
    table: "Table K(ii) – Interlocutory Appeal",
    note: "Counsel preparation for interlocutory appeal (2 hours, includes submissions)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "INTERLOCUTORY LEAVE APPLICATION",
    feeType: "INTERLOCUTORY LEAVE APPLICATION",
    amountLabel: "1 APPEARANCE @ $1,511.00",
    table: "Table K(ii) – Interlocutory Appeal",
    note: "Leave application appearance for interlocutory appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "INTERLOCUTORY APPEAL APPEARANCE",
    feeType: "INTERLOCUTORY APPEAL APPEARANCE",
    amountLabel: "1 APPEARANCE @ $2,269.00",
    table: "Table K(ii) – Interlocutory Appeal",
    note: "First day appeal appearance for interlocutory appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "INTERLOCUTORY SUBSEQUENT",
    feeType: "INTERLOCUTORY SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,511.00",
    table: "Table K(ii) – Interlocutory Appeal",
    note: "Subsequent days for interlocutory appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
];

// =============================================
// TABLE L — High Court Criminal Appeals
// =============================================
export const HIGH_COURT_CLAIM_ROWS = [
  // --- Special leave ---
  {
    appearanceType: "HC SPECIAL LEAVE PREPARATION",
    feeType: "HC SPECIAL LEAVE PREPARATION",
    amountLabel: "LUMP SUM $3,129.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Special leave preparation (10.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "HC SPECIAL LEAVE APPEARANCE",
    feeType: "HC SPECIAL LEAVE APPEARANCE",
    amountLabel: "1 APPEARANCE @ $2,269.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Special leave hearing appearance",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "HC SPECIAL LEAVE SUBSEQUENT",
    feeType: "HC SPECIAL LEAVE SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,511.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Subsequent days for special leave hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "HC SPECIAL LEAVE JUDGMENT",
    feeType: "HC SPECIAL LEAVE JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Judgment appearance for special leave application",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "HC SPECIAL LEAVE GROUNDS AND SUBMISSIONS",
    feeType: "HC SPECIAL LEAVE GROUNDS AND SUBMISSIONS",
    amountLabel: "LUMP SUM $3,260.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Grounds and written submissions for special leave (10 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  // --- Appeal ---
  {
    appearanceType: "HC APPEAL PREPARATION",
    feeType: "HC APPEAL PREPARATION",
    amountLabel: "LUMP SUM $3,725.00",
    table: "Table L – High Court Criminal Appeals",
    note: "High Court appeal preparation (12.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "HC APPEAL APPEARANCE",
    feeType: "HC APPEAL APPEARANCE",
    amountLabel: "1 APPEARANCE @ $2,269.00",
    table: "Table L – High Court Criminal Appeals",
    note: "High Court appeal hearing — first day",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "HC APPEAL SUBSEQUENT",
    feeType: "HC APPEAL SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,511.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Subsequent days for High Court appeal hearing",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "HC APPEAL JUDGMENT",
    feeType: "HC APPEAL JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Judgment appearance for High Court appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "HC APPEAL GROUNDS AND SUBMISSIONS",
    feeType: "HC APPEAL GROUNDS AND SUBMISSIONS",
    amountLabel: "LUMP SUM $3,260.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Grounds and written submissions for High Court appeal (10 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "HC APPEAL INSTRUCTING HALF DAY",
    feeType: "HC APPEAL INSTRUCTING HALF DAY",
    amountLabel: "1 APPEARANCE @ $752.00",
    table: "Table L – High Court Criminal Appeals",
    note: "Instructing solicitor half-day appearance for High Court appeal",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

// =============================================
// TABLE T — Mental Impairment Act (CMIA) — County Court
// =============================================
export const MENTAL_IMPAIRMENT_CC_CLAIM_ROWS = [
  {
    appearanceType: "CMIA CC ROUTINE APPEARANCE",
    feeType: "CMIA CC ROUTINE APPEARANCE",
    amountLabel: "3 APPEARANCE(s) @ $707.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "Routine appearance and conference at County Court under CMIA",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA CC PREPARATION",
    feeType: "CMIA CC PREPARATION",
    amountLabel: "LUMP SUM $1,496.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "Preparation for CMIA hearing at County Court (8 hours @ $187)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA CC APPEARANCE DAY 1",
    feeType: "CMIA CC APPEARANCE DAY 1",
    amountLabel: "1 APPEARANCE @ $2,982.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "First day of CMIA hearing at County Court (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA CC SUBSEQUENT",
    feeType: "CMIA CC SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,370.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "Subsequent days of CMIA hearing at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA CC MENTION",
    feeType: "CMIA CC MENTION",
    amountLabel: "3 APPEARANCE(s) @ $297.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "Mention appearance at County Court under CMIA",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA CC JUDGMENT",
    feeType: "CMIA CC JUDGMENT",
    amountLabel: "1 APPEARANCE @ $356.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "Judgment appearance at County Court under CMIA",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA CC INSTRUCTING",
    feeType: "CMIA CC INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $165.00",
    table: "Table T – Mental Impairment Act (CMIA) County Court",
    note: "Instructing solicitor fee per hour for CMIA matter at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
];

// =============================================
// TABLE T — Mental Impairment Act (CMIA) — Supreme Court
// =============================================
export const MENTAL_IMPAIRMENT_SC_CLAIM_ROWS = [
  {
    appearanceType: "CMIA SC ROUTINE APPEARANCE",
    feeType: "CMIA SC ROUTINE APPEARANCE",
    amountLabel: "3 APPEARANCE(s) @ $1,344.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "Routine appearance and conference at Supreme Court under CMIA",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA SC PREPARATION",
    feeType: "CMIA SC PREPARATION",
    amountLabel: "LUMP SUM $2,384.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "Preparation for CMIA hearing at Supreme Court (8 hours @ $298)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA SC APPEARANCE DAY 1",
    feeType: "CMIA SC APPEARANCE DAY 1",
    amountLabel: "1 APPEARANCE @ $4,737.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "First day of CMIA hearing at Supreme Court (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA SC SUBSEQUENT",
    feeType: "CMIA SC SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $2,197.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "Subsequent days of CMIA hearing at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA SC MENTION",
    feeType: "CMIA SC MENTION",
    amountLabel: "3 APPEARANCE(s) @ $407.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "Mention appearance at Supreme Court under CMIA",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA SC JUDGMENT",
    feeType: "CMIA SC JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "Judgment appearance at Supreme Court under CMIA",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "CMIA SC INSTRUCTING",
    feeType: "CMIA SC INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $298.00",
    table: "Table T – Mental Impairment Act (CMIA) Supreme Court",
    note: "Instructing solicitor fee per hour for CMIA matter at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
];

// =============================================
// TABLE Y — Chief Examiner / Witness Assistance
// =============================================
export const CHIEF_EXAMINER_CLAIM_ROWS = [
  {
    appearanceType: "CHIEF EXAMINER ADVICE",
    feeType: "CHIEF EXAMINER ADVICE",
    amountLabel: "LUMP SUM $467.00",
    table: "Table Y – Chief Examiner / Witness Assistance",
    note: "Advice for Chief Examiner witness (2.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "CHIEF EXAMINER BRIEF DAILY",
    feeType: "CHIEF EXAMINER BRIEF DAILY",
    amountLabel: "3 DAY(s) @ $1,350.00",
    table: "Table Y – Chief Examiner / Witness Assistance",
    note: "Daily brief for Chief Examiner hearing (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
];

// =============================================
// TABLE Z — Serious Offenders Act 2018
// =============================================
export const SERIOUS_OFFENDERS_CC_CLAIM_ROWS = [
  // --- Supervision orders (CC) ---
  {
    appearanceType: "SOA CC SUPERVISION PREPARATION",
    feeType: "SOA CC SUPERVISION PREPARATION",
    amountLabel: "LUMP SUM $935.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Supervision order preparation at County Court (5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC SUPERVISION BRIEF",
    feeType: "SOA CC SUPERVISION BRIEF",
    amountLabel: "1 APPEARANCE @ $2,501.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Supervision order hearing brief at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC SUPERVISION SUBSEQUENT",
    feeType: "SOA CC SUPERVISION SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $1,370.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Subsequent days for supervision order hearing at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC SUPERVISION MENTION",
    feeType: "SOA CC SUPERVISION MENTION",
    amountLabel: "3 APPEARANCE(s) @ $298.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Supervision order mention at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC SUPERVISION INSTRUCTING",
    feeType: "SOA CC SUPERVISION INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $165.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Instructing solicitor fee per hour for SOA supervision at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC SUPERVISION JUDGMENT",
    feeType: "SOA CC SUPERVISION JUDGMENT",
    amountLabel: "1 APPEARANCE @ $356.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Judgment appearance for SOA supervision order at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Application for review (CC) ---
  {
    appearanceType: "SOA CC REVIEW PREPARATION",
    feeType: "SOA CC REVIEW PREPARATION",
    amountLabel: "LUMP SUM $935.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Review application preparation at County Court (5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC REVIEW APPEARANCE",
    feeType: "SOA CC REVIEW APPEARANCE",
    amountLabel: "3 DAY(s) @ $1,087.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Review application hearing at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC REVIEW MENTION",
    feeType: "SOA CC REVIEW MENTION",
    amountLabel: "3 APPEARANCE(s) @ $298.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Review application mention at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA CC REVIEW JUDGMENT",
    feeType: "SOA CC REVIEW JUDGMENT",
    amountLabel: "1 APPEARANCE @ $356.00",
    table: "Table Z – Serious Offenders Act 2018 (County Court)",
    note: "Judgment appearance for SOA review at County Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

export const SERIOUS_OFFENDERS_SC_CLAIM_ROWS = [
  // --- Emergency detention orders (SC only) ---
  {
    appearanceType: "SOA SC EDO PREPARATION",
    feeType: "SOA SC EDO PREPARATION",
    amountLabel: "LUMP SUM $1,043.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Emergency detention order preparation at Supreme Court (3.5 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC EDO APPEARANCE",
    feeType: "SOA SC EDO APPEARANCE",
    amountLabel: "3 DAY(s) @ $1,050.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Emergency detention order hearing at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC EDO MENTION",
    feeType: "SOA SC EDO MENTION",
    amountLabel: "3 APPEARANCE(s) @ $408.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Emergency detention order mention at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC EDO JUDGMENT",
    feeType: "SOA SC EDO JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Judgment appearance for SOA emergency detention order",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Detention orders (SC only) ---
  {
    appearanceType: "SOA SC DETENTION PREPARATION",
    feeType: "SOA SC DETENTION PREPARATION",
    amountLabel: "LUMP SUM $2,980.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Detention order preparation at Supreme Court (10 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC DETENTION BRIEF",
    feeType: "SOA SC DETENTION BRIEF",
    amountLabel: "1 APPEARANCE @ $4,737.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Detention order hearing brief at Supreme Court (includes conferences)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC DETENTION SUBSEQUENT",
    feeType: "SOA SC DETENTION SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $2,197.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Subsequent days for detention order hearing at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC DETENTION MENTION",
    feeType: "SOA SC DETENTION MENTION",
    amountLabel: "3 APPEARANCE(s) @ $408.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Detention order mention at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC DETENTION INSTRUCTING",
    feeType: "SOA SC DETENTION INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $298.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Instructing solicitor fee per hour for SOA detention order at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC DETENTION JUDGMENT",
    feeType: "SOA SC DETENTION JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Judgment appearance for SOA detention order",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Supervision orders (SC) ---
  {
    appearanceType: "SOA SC SUPERVISION PREPARATION",
    feeType: "SOA SC SUPERVISION PREPARATION",
    amountLabel: "LUMP SUM $2,086.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Supervision order preparation at Supreme Court (7 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC SUPERVISION BRIEF",
    feeType: "SOA SC SUPERVISION BRIEF",
    amountLabel: "1 APPEARANCE @ $4,074.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Supervision order hearing brief at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC SUPERVISION SUBSEQUENT",
    feeType: "SOA SC SUPERVISION SUBSEQUENT",
    amountLabel: "3 DAY(s) @ $2,197.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Subsequent days for supervision order hearing at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC SUPERVISION MENTION",
    feeType: "SOA SC SUPERVISION MENTION",
    amountLabel: "3 APPEARANCE(s) @ $408.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Supervision order mention at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC SUPERVISION INSTRUCTING",
    feeType: "SOA SC SUPERVISION INSTRUCTING",
    amountLabel: "5 HOUR(s) @ $298.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Instructing solicitor fee per hour for SOA supervision at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 5,
    allocationUnit: "hour",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC SUPERVISION JUDGMENT",
    feeType: "SOA SC SUPERVISION JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Judgment appearance for SOA supervision order at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  // --- Application for review (SC) ---
  {
    appearanceType: "SOA SC REVIEW PREPARATION",
    feeType: "SOA SC REVIEW PREPARATION",
    amountLabel: "LUMP SUM $2,086.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Review application preparation at Supreme Court (7 hours)",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC REVIEW APPEARANCE",
    feeType: "SOA SC REVIEW APPEARANCE",
    amountLabel: "3 DAY(s) @ $2,273.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Review application hearing at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC REVIEW MENTION",
    feeType: "SOA SC REVIEW MENTION",
    amountLabel: "3 APPEARANCE(s) @ $408.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Review application mention at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "SOA SC REVIEW JUDGMENT",
    feeType: "SOA SC REVIEW JUDGMENT",
    amountLabel: "1 APPEARANCE @ $491.00",
    table: "Table Z – Serious Offenders Act 2018 (Supreme Court)",
    note: "Judgment appearance for SOA review at Supreme Court",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
];

// =============================================
// TABLE A5 — Personal Safety Intervention Orders
// =============================================
export const PSIO_CLAIM_ROWS = [
  {
    appearanceType: "PSIO PREPARATION",
    feeType: "PSIO PREPARATION",
    amountLabel: "LUMP SUM $431.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Preparation for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO URGENT PREPARATION",
    feeType: "PSIO URGENT PREPARATION",
    amountLabel: "LUMP SUM $247.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Urgent preparation for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO DIRECTIONS HEARING",
    feeType: "PSIO DIRECTIONS HEARING",
    amountLabel: "3 APPEARANCE(s) @ $161.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Directions hearing appearance for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO APPEARANCE",
    feeType: "PSIO APPEARANCE",
    amountLabel: "3 DAY(s) @ $431.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "General hearing appearance for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO CONTEST APPEARANCE",
    feeType: "PSIO CONTEST APPEARANCE",
    amountLabel: "3 DAY(s) @ $605.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Contested hearing appearance for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO ADJOURNMENT",
    feeType: "PSIO ADJOURNMENT",
    amountLabel: "2 APPEARANCE(s) @ $431.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Adjournment appearance for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO TRAVEL",
    feeType: "PSIO TRAVEL",
    amountLabel: "600 KM @ $0.83",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Travel fee per kilometre for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 600,
    allocationUnit: "km",
    trackerAliases: [],
  },
  {
    appearanceType: "PSIO OVERNIGHT",
    feeType: "PSIO OVERNIGHT",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table A5 – Personal Safety Intervention Orders",
    note: "Overnight accommodation allowance for PSIO matter",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: [],
  },
];

// =============================================
// TABLE NN — Circuit fees (pleas/bail/committals) by town
// =============================================
export const CIRCUIT_FEES_NN = {
  ARARAT: { firstDay: 259, subsequentDay: 171, overnight: 394 },
  BAIRNSDALE: { firstDay: 286, subsequentDay: 190, overnight: 394 },
  BALLARAT: { firstDay: 187, subsequentDay: 126, overnight: 394 },
  BENDIGO: { firstDay: 214, subsequentDay: 141, overnight: 394 },
  COLAC: { firstDay: 217, subsequentDay: 141, overnight: 394 },
  GEELONG: { firstDay: 151, subsequentDay: 98, overnight: 394 },
  HAMILTON: { firstDay: 300, subsequentDay: 197, overnight: 394 },
  HORSHAM: { firstDay: 300, subsequentDay: 197, overnight: 394 },
  KERANG: { firstDay: 300, subsequentDay: 197, overnight: 394 },
  KORUMBURRA: { firstDay: 187, subsequentDay: 126, overnight: 394 },
  MILDURA: { firstDay: 363, subsequentDay: 245, overnight: 394, note: "If return economy airfare > first day circuit fee, VLA pays airfare instead" },
  MORWELL: { firstDay: 217, subsequentDay: 141, overnight: 394 },
  SALE: { firstDay: 259, subsequentDay: 168, overnight: 394 },
  SHEPPARTON: { firstDay: 247, subsequentDay: 165, overnight: 394 },
  WANGARATTA: { firstDay: 272, subsequentDay: 185, overnight: 394 },
  WARRAGUL: { firstDay: 197, subsequentDay: 132, overnight: 394 },
  WARRNAMBOOL: { firstDay: 286, subsequentDay: 190, overnight: 394 },
  WODONGA: { firstDay: 300, subsequentDay: 197, overnight: 394 },
};

// =============================================
// TABLE RR — Counsel circuit fees for trials (per 5-day period)
// =============================================
export const CIRCUIT_FEES_RR = {
  ARARAT: 749,
  BAIRNSDALE: 1125,
  BALLARAT: 373,
  BENDIGO: 562,
  COLAC: 562,
  GEELONG: 187,
  HAMILTON: 1125,
  HORSHAM: 1220,
  KERANG: 1125,
  KORUMBURRA: 373,
  MILDURA: 1450,
  MORWELL: 562,
  SALE: 843,
  SHEPPARTON: 656,
  WANGARATTA: 939,
  WARRAGUL: 373,
  WARRNAMBOOL: 1032,
  WODONGA: 1220,
};

// =============================================
// TABLE S — Expert Disbursements (Psychological/Psychiatric)
// =============================================
export const EXPERT_FEES_TABLE_S = {
  psychologist: [
    { service: "Assessment and report with jail conference", fee: 850 },
    { service: "Assessment and report without jail conference", fee: 746 },
    { service: "Treating expert report", fee: 475 },
    { service: "Supplementary report", fee: 416 },
    { service: "Evidentiary report (mental impairment/fitness to plead)", fee: 1125 },
    { service: "Attendance at metropolitan court – half day, including travel", fee: 523 },
    { service: "Attendance at regional court – half day, including travel", fee: 746 },
    { service: "Non-attendance fee", fee: 82 },
  ],
  psychiatrist: [
    { service: "Assessment and report with jail conference", fee: 957 },
    { service: "Assessment and report without jail conference", fee: 850 },
    { service: "Treating expert report", fee: 577 },
    { service: "Supplementary report", fee: 523 },
    { service: "Evidentiary report (mental impairment/fitness to plead)", fee: 1125 },
    { service: "Attendance at metropolitan court – half day, including travel", fee: 638 },
    { service: "Attendance at regional court – half day, including travel", fee: 850 },
    { service: "Non-attendance fee", fee: 113 },
  ],
  // Guideline 3.2 – assistance with migration matters. Not criminal work, kept so the table
  // is complete.
  migration: [
    { service: "Psychologist assessment and report", fee: 850 },
    { service: "Psychologist supplementary report", fee: 416 },
    { service: "Psychiatrist assessment and report", fee: 957 },
    { service: "Psychiatrist supplementary report", fee: 523 },
    { service: "Attending court or tribunal, including travel – half day", fee: 638 },
    { service: "Attending court or tribunal, including travel – full day", fee: 975 },
  ],
};

// =============================================
// TABLE A — Summary criminal fees by number of accused
// =============================================
// The claim tracker holds the single-accused rates (the grant letter sets the allocation).
// Where one lawyer acts for two, or three or more, accused, VLA pays these rates instead.
export const SUMMARY_CRIME_FEES_BY_ACCUSED = [
  { service: "Lump sum general preparation fee", single: 484, two: 726, threeOrMore: 966 },
  { service: "Lump sum preparation fee (urgent matter)", single: 277, two: 414, threeOrMore: 552 },
  { service: "Lump sum consolidated preparation fee", single: 579, two: 868, threeOrMore: 1158 },
  { service: "Lump sum consolidated preparation fee (urgent matter)", single: 348, two: 522, threeOrMore: 696 },
  { service: "Transcribing taped record of interview (per tape)", single: 99, two: 99, threeOrMore: 99 },
  { service: "Contest mention", single: 332, two: 498, threeOrMore: 663 },
  { service: "Consolidated contest mention", single: 581, two: 746, threeOrMore: 912 },
  { service: "Jail conference", single: 185, two: 185, threeOrMore: 185 },
  { service: "Contest hearing appearance", single: 1099, two: 1648, threeOrMore: 2196 },
  { service: "Daily appearance fee", single: 484, two: 726, threeOrMore: 966 },
  { service: "Daily appearance fee (consolidation)", single: 579, two: 868, threeOrMore: 1158 },
  { service: "Appearance on sentence or adjournment", single: 318, two: 476, threeOrMore: 636 },
  { service: "Appearance on sentence or adjournment (consolidation)", single: 369, two: 552, threeOrMore: 738 },
  { service: "Appearance at mention hearing", single: 185, two: null, threeOrMore: null },
  { service: "Appearance at special mention", single: 185, two: null, threeOrMore: null },
  { service: "Group conference – work hours (Children's Court)", single: 464, two: 696, threeOrMore: 927 },
  { service: "Group conference – outside work hours (Children's Court)", single: 594, two: 890, threeOrMore: 1188 },
  { service: "Youth Control Order planning meeting (Children's Court)", single: 358, two: null, threeOrMore: null },
  { service: "YCO reporting and monitoring hearing (Children's Court)", single: 185, two: null, threeOrMore: null },
  { service: "YCO hearing opposing a significantly more restrictive variation (Children's Court)", single: 318, two: null, threeOrMore: null },
  { service: "Breach or revocation of a YCO (Children's Court)", single: 484, two: 726, threeOrMore: 966 },
  { service: "Application for summary jurisdiction (Children's Court)", single: 890, two: null, threeOrMore: null },
  { service: "Plea heard at contest mention – contest mention fee", single: 332, two: 498, threeOrMore: 663 },
  { service: "Plea heard at contest mention – contest mention fee (consolidation)", single: 581, two: 746, threeOrMore: 912 },
  { service: "Plea heard at contest mention – plea fee", single: 318, two: 476, threeOrMore: 636 },
  { service: "Plea heard at contest mention – plea fee (consolidation)", single: 369, two: 552, threeOrMore: 738 },
  { service: "CISP / Drug Court mention", single: 185, two: 185, threeOrMore: 185 },
  { service: "ARC – Individual Support Plan ratification hearing", single: 332, two: null, threeOrMore: null },
  { service: "ARC review hearing", single: 185, two: null, threeOrMore: null },
];

// =============================================
// TABLE BBB — Fees if an Appeal Costs Certificate has been granted (Fee Schedule 1A)
// =============================================
// payer: who the fee is paid to. perHour / perDay mark rates rather than single fees.
export const APPEAL_COSTS_CERTIFICATE_FEES_BBB = [
  { court: "Magistrates' Court", activity: "Hearing (summary crime) – appearance fee in all matters", payer: "lawyer", fee: 484 },
  { court: "Magistrates' Court", activity: "Contest hearing appearance if the matter does not proceed as a contest", payer: "lawyer", fee: 656 },
  { court: "Magistrates' Court", activity: "Hearing (summary crime) – consolidation", payer: "lawyer", fee: 579 },
  { court: "Magistrates' Court", activity: "Contest mention (summary crime)", payer: "lawyer", fee: 332 },
  { court: "Magistrates' Court", activity: "Contested committal – second day fee", payer: "lawyer", fee: 1157 },
  { court: "Magistrates' Court", activity: "Committal mention", payer: "lawyer", fee: 447 },
  { court: "County Court", activity: "Appeal – brief fee", payer: "counsel", fee: 968, perDay: true },
  { court: "County Court", activity: "Plea – second day fee", payer: "counsel", fee: 638, perDay: true },
  { court: "County Court", activity: "Trial, single day adjournment – subsequent day fee", payer: "counsel", fee: 1370, perDay: true },
  { court: "County Court", activity: "Trial, single day adjournment – one hour instructing fee (max 2 adjournments a day)", payer: "lawyer", fee: 165 },
  { court: "County Court", activity: "Retrial beginning less than 10 days after the first trial – subsequent day fees", payer: "counsel", fee: 1370, perDay: true },
  { court: "County Court", activity: "Retrial beginning more than 10 days after the first trial – brief fee", payer: "counsel", fee: 2982 },
  { court: "County Court", activity: "Immediate retrial – instructing (max 5 hours a day)", payer: "lawyer", fee: 165, perHour: true },
  { court: "County Court", activity: "Retrial beginning more than 5 days after the first trial – 20% of trial preparation", payer: "lawyer", fee: 374 },
  { court: "County Court", activity: "Retrial beginning 21 days or more after the first trial – 40% of trial preparation", payer: "lawyer", fee: 748 },
  { court: "County Court", activity: "Retrial beginning 3 months or more after the first trial – full trial preparation", payer: "lawyer", fee: 1870 },
  { court: "Supreme Court", activity: "Appeal – brief fee", payer: "counsel", fee: 2269, perDay: true },
  { court: "Supreme Court", activity: "Plea – second day fee", payer: "counsel", fee: 1002 },
  { court: "Supreme Court", activity: "Trial, single day adjournment – subsequent day fee", payer: "counsel", fee: 2197, perDay: true },
  { court: "Supreme Court", activity: "Trial, single day adjournment – one hour instructing fee (max 2 adjournments a day)", payer: "lawyer", fee: 298 },
  { court: "Supreme Court", activity: "Retrial beginning less than 10 days after the first trial – subsequent day fee", payer: "counsel", fee: 2197, perDay: true },
  { court: "Supreme Court", activity: "Retrial beginning more than 10 days after the first trial – brief fee", payer: "counsel", fee: 4737 },
  { court: "Supreme Court", activity: "Retrial – instructing (max 5 hours a day)", payer: "lawyer", fee: 298, perHour: true },
  { court: "Supreme Court", activity: "Retrial beginning more than 5 days after the first trial – 20% of trial preparation", payer: "lawyer", fee: 894 },
  { court: "Supreme Court", activity: "Retrial beginning 21 days or more after the first trial – 40% of trial preparation", payer: "lawyer", fee: 1788 },
  { court: "Supreme Court", activity: "Retrial beginning 3 months or more after the first trial – full trial preparation", payer: "lawyer", fee: 4470 },
];
